<template>
  <base-dialog
    :action="onAction"
    :action-name="'Cancel subscription'"
    :cancel-name="'Don\'t Cancel'"
    :close="onClose"
    :title="'Cancel subscription'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
        <v-row>
          <v-col cols="12">
            <v-radio-group
              v-model="cancelImmediately"
              mandatory
            >
              <v-radio
                color="primary"
                label="Cancel immediately"
                :value="true"
              />
              <v-switch
                class="mt-0"
                v-if="cancelImmediately"
                v-model="prorate"
                :label="`Prorate: ${prorate ? 'Yes' : 'No'}`"
              />

              <v-radio
                color="primary"
                :label="`Cancel at the end of the current period ${_formatDate(currentPeriodEnd)}`"
                :value="false"
              />
            </v-radio-group>
          </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { formatDate, isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
    currentPeriodEnd: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cancelImmediately: true,
      prorate: true
    }
  },
  methods:{
    ...mapActions(['cancelSubscriptionImmediately', 'cancelSubscriptionAtPeriodEnd']),
    _formatDate: date => formatDate(date),
    onClose(){
      this.$emit('close')
    },
    onAction() {
      const payload = {
        id: this.id,
        prorate: this.prorate
      }

      if(this.cancelImmediately) {
        return this.cancelSubscriptionImmediately(payload)
          .then(res=> {
            if(!isErrorResponse(res)) {
              this.$emit('action', payload)
            }

            return res
          })
      } else {
        return this.cancelSubscriptionAtPeriodEnd(payload)
          .then(res=> {
            if(!isErrorResponse(res)) {
              this.$emit('action', payload)
            }

            return res
          })
      }
    }
  }
}
</script>
